export type MergeStringsT = (...classes: (string | false | null | undefined)[]) => string;

export const mergeClassNameStrings: MergeStringsT = (...classes) => classes.filter(Boolean).join(' ');

export const emailAddressPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const poBoxPattern = /\b(?:p(?:ost)?\.?\s*o(?:ffice)?\.?\s*box|po\s*box)\b/i;
export const postalCodePattern = /^\d{5}$/;

export const capitalize = <T extends string>(str?: T) => {
  if (typeof str === 'string' && str.length) {
    return (str.charAt(0).toUpperCase() + str.slice(1)) as Capitalize<T>;
  }

  return undefined;
};

export const toCamelCase: (filename: string) => string = (filename) => {
  const [first, ...rest] = filename.split(/[_\-/]/);

  return [first, ...rest.map((str) => capitalize(str))].join('');
};

// Helper to format currency amounts as strings with or without cents
export const currencyString = (amount: number, withoutCents = false): string => (
  new Intl.NumberFormat(
    'en-US',
    {
      currency: 'USD',
      maximumFractionDigits: withoutCents ? 0 : 2,
      minimumFractionDigits: withoutCents ? 0 : 2,
      style: 'currency',
    },
  ).format(amount)
);

export const snakeToKebabCase = (str: string): string => str.replace(/_/g, '-');
